module.exports.stockdata=[
  {
    "name": "TATASTEEL ",
    "price": 10.949999999999818,
    "average": 593.225
  },
  {
    "name": "TITAN ",
    "price": -23,
    "average": 823.6750000000001
  },
  {
    "name": "BRITANNIA ",
    "price": 101.25000000000091,
    "average": 2102.95
  },
  {
    "name": "MM ",
    "price": 18.5,
    "average": 602.95
  },
  {
    "name": "COALINDIA ",
    "price": 2.850000000000364,
    "average": 237.8
  },
  {
    "name": "JSWSTEEL ",
    "price": -32.80000000000109,
    "average": 554
  },
  {
    "name": "NESTLEIND ",
    "price": 255.64999999999964,
    "average": 9401.95
  },
  {
    "name": "ICICIBANK ",
    "price": 10.100000000000364,
    "average": 337.625
  },
  {
    "name": "MARUTI ",
    "price": 22.099999999999454,
    "average": 3309.975
  },
  {
    "name": "ULTRACEMCO ",
    "price": -19.099999999999454,
    "average": 3269.575
  },
  {
    "name": "WIPRO ",
    "price": -3418.9999999999995,
    "average": 1608.475
  },
  {
    "name": "NIFTY50_all ",
    "price": -219.75,
    "average": 574.25
  },
  {
    "name": "NTPC ",
    "price": 13.650000000000546,
    "average": 89
  },
  {
    "name": "VEDL ",
    "price": -15.650000000000546,
    "average": 186.8
  },
  {
    "name": "ASIANPAINT ",
    "price": -63.850000000000364,
    "average": 1459.025
  },
  {
    "name": "ONGC ",
    "price": -93.5,
    "average": 160.8
  },
  {
    "name": "IOC ",
    "price": -19.099999999999454,
    "average": 180.85000000000002
  },
  {
    "name": "DRREDDY ",
    "price": -20.550000000000182,
    "average": 3335.675
  },
  {
    "name": "TECHM ",
    "price": -284.2000000000007,
    "average": 757.325
  },
  {
    "name": "TCS ",
    "price": 40.100000000000364,
    "average": 2011.8000000000002
  },
  {
    "name": "SUNPHARMA ",
    "price": -1490.1999999999998,
    "average": 1244.75
  },
  {
    "name": "HCLTECH ",
    "price": 191.75000000000182,
    "average": 1226.7
  },
  {
    "name": "HDFC ",
    "price": -2.5,
    "average": 1356.8
  },
  {
    "name": "KOTAKBANK ",
    "price": -45.14999999999873,
    "average": 989.0749999999999
  },
  {
    "name": "ZEEL ",
    "price": -10.549999999999272,
    "average": 682.775
  },
  {
    "name": "AXISBANK ",
    "price": 11.199999999998909,
    "average": 370.8
  },
  {
    "name": "EICHERMOT ",
    "price": -5.699999999999818,
    "average": 1235.25
  },
  {
    "name": "HDFCBANK ",
    "price": 4.900000000001455,
    "average": 791.15
  },
  {
    "name": "TATAMOTORS ",
    "price": -4.800000000000182,
    "average": 255.3
  },
  {
    "name": "HEROMOTOCO ",
    "price": 6.349999999999454,
    "average": 2013.375
  },
  {
    "name": "UPL ",
    "price": -15.650000000000546,
    "average": 580.3499999999999
  },
  {
    "name": "CIPLA ",
    "price": -13.149999999999636,
    "average": 1183.85
  },
  {
    "name": "BAJAJ-AUTO ",
    "price": 191.20000000000073,
    "average": 2219.25
  },
  {
    "name": "ITC ",
    "price": 129.05000000000018,
    "average": 455.55
  },
  {
    "name": "GAIL ",
    "price": 3.8999999999987267,
    "average": 102.94999999999999
  },
  {
    "name": "POWERGRID ",
    "price": 21.649999999999636,
    "average": 160.325
  },
  {
    "name": "HINDALCO ",
    "price": -29.25000000000091,
    "average": 615.925
  },
  {
    "name": "BPCL ",
    "price": 54.30000000000018,
    "average": 410.525
  },
  {
    "name": "LT ",
    "price": 57.94999999999982,
    "average": 988.2
  },
  {
    "name": "ADANIPORTS ",
    "price": -219.75,
    "average": 846.4749999999999
  },
  {
    "name": "HINDUNILVR ",
    "price": 16.700000000001637,
    "average": 2330.65
  },
  {
    "name": "GRASIM ",
    "price": 18.649999999999636,
    "average": 920.025
  },
  {
    "name": "RELIANCE ",
    "price": 237.84999999999945,
    "average": 1123.1
  },
  {
    "name": "INFY ",
    "price": 0,
    "average": 8489.775
  },
  {
    "name": "SHREECEM ",
    "price": -7.899999999999636,
    "average": 13987.625
  },
  {
    "name": "SBIN ",
    "price": 78.00000000000091,
    "average": 298.575
  },
  {
    "name": "INDUSINDBK ",
    "price": -0.7500000000009095,
    "average": 481.95000000000005
  },
  {
    "name": "BAJAJFINSV ",
    "price": -83.35000000000036,
    "average": 5775.375
  },
  {
    "name": "BAJFINANCE ",
    "price": 12.50000000000091,
    "average": 2751.325
  }
]